/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:691ba8cc-fa5c-430a-8664-565631ca26de",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_0GgGYQFyg",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_user_files_s3_bucket": "powderlog-tracks-powderlog",
    "aws_user_files_s3_bucket_region": "eu-west-2",
    "aws_dynamodb_all_tables_region": "eu-west-2",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "PowderLogTable-powderlog"
        }
    ],
    "Auth": {
        "Cognito": {
            "userPoolId": "eu-west-2_0GgGYQFyg",
            "userPoolClientId": "7rqo1vsia8mqsdtdpp4u9cmto3",
            "identityPoolId": "eu-west-2:691ba8cc-fa5c-430a-8664-565631ca26de",
            "loginWith": {
                "oauth": {
                    "domain": "powderlog-auth-powderlog.auth.eu-west-2.amazoncognito.com",
                    "scopes": [
                        "openid",
                        "email",
                        "profile",
                        "aws.cognito.signin.user.admin"
                    ],
                    "redirectSignIn": [
                        "capacitor://localhost/auth/callback",
                        "http://localhost:3000/auth/callback",
                        "https://powderlog.dx88x792j1ocl.amplifyapp.com/auth/callback",
                        "https://powderlog.wolftechnologies.co.uk/auth/callback"
                    ],
                    "redirectSignOut": [
                        "capacitor://localhost/login",
                        "http://localhost:3000/login",
                        "https://powderlog.dx88x792j1ocl.amplifyapp.com/login",
                        "https://powderlog.wolftechnologies.co.uk/login"
                    ],
                    "responseType": "code",
                    "providers": [
                        {
                            "custom": "SignInWithApple"
                        }
                    ]
                },
                "email": true,
                "username": false
            },
            "passwordFormat": {
                "minLength": 8,
                "requireLowercase": true,
                "requireUppercase": true,
                "requireNumbers": true,
                "requireSpecialCharacters": false
            },
            "mfa": {
                "status": "optional",
                "totpEnabled": true,
                "smsEnabled": false
            },
            "signUpVerificationMethod": "code"
        }
    },
    "Storage": {
        "S3": {
            "bucket": "powderlog-tracks-powderlog",
            "region": "eu-west-2"
        }
    },
    "API": {
        "REST": {
            "powderlogApi": {
                "endpoint": "https://ufvz2izpyl.execute-api.eu-west-2.amazonaws.com/powderlog",
                "region": "eu-west-2"
            }
        }
    }
};


export default awsmobile;
